/**
 * @license
 * jabm.dev
 * Copyright (C) 2024–present JustABoredMaker.

 * This file is part of jabm.dev.

 * jabm.dev is free software: you can redistribute it and/or modify it under the
 * terms of the GNU General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later
 * version.

 * jabm.dev is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License along with
 * jabm.dev. If not, see <https://www.gnu.org/licenses/>.
 *
 * Home: https://gitlab.com/JustABoredMaker/jabm.dev
 */

// Match site theme to user's system preference
if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
	document.body.dataset.theme = "dark";
} else {
	document.body.dataset.theme = "light";
}

/** Toggle body theme between dark & light */
function setTheme(): void {
	if (document.body.dataset.theme === "dark") {
		document.body.dataset.theme = "light";
	} else if (document.body.dataset.theme === "light") {
		document.body.dataset.theme = "dark";
	}
}

const buttonToggleTheme: HTMLButtonElement | null = document.querySelector("button.change-theme");

if (!buttonToggleTheme) {
	throw new TypeError("Toggle Theme Button doesn't exist.");
}

buttonToggleTheme.addEventListener("click", setTheme);
